import React, { useEffect, useState } from "react";
import PreFilter from "../../../../components/BuilderComponents/PreFilters/PreFilter";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import "./RecordsView.css";
import EditActions from "./RecordsViewEdit/EditActions";
import EditColumns from "./RecordsViewEdit/Columns/EditColumns";
import EditFilters from "./RecordsViewEdit/EditFilters";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import ColumnPreFilters from "../../../../components/BuilderComponents/PreFilters/ColumnPreFilters";
import BlockTiles from "../../ChartRenderer/BlockTiles";
import SingleJobPopup from "../../../../components/BuilderComponents/JobConfigration/SingleJobPopup";
import axiosInstance, { handleApiError } from "../../../../services/axiosService";
import { useTreeContext } from "../../../../context/TreeDataContext";
import BuilderTabs from "../../../../Layouts/BuilderTabs";
import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import Button from "../../../../components/FormComponents/Button";
import { HiddenColumns } from "../Mobile/MobileRecordEditSection";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const RecordsViewEditSection = ({
  isMapBlock = false,
  afterEffectOfFilter,
  tableRef,
  nonSelectedFilter,
  setNonSelectedFilter
}) => {
  const [isModalOpen, setIsModalOpen] = useState(null);
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();

  const handleChangeColumnPreFilters = (data) => {
    const newLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    newLayout.column_pre_filters = data;
    setRecordsviewLayout(newLayout);
  };

  const addFieldLocationCallbackFunction = (data) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    if (isModalOpen === "add") {
      newObj.location_point = data.id;
    }
    setRecordsviewLayout(newObj);
    setIsModalOpen(false);
  };

  const settingTiles = (data) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    newObj.tiles = data;
    setRecordsviewLayout(newObj);
  };
  const callbackFunctionOfOwnerAnePreFilter = (value, data) => {
    const newLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    newLayout[value] = data;
    setRecordsviewLayout(newLayout);
  };

  const settingActions = (data) => {
    const newObj = JSON.parse(JSON.stringify(recordsviewLayout));
    newObj.multi_select_custom_actions = data;
    setRecordsviewLayout(newObj);
  };

  const tabArray = isMapBlock
    ? ["Columns", "Filters", "Pre-Filters", "Location"]
    : ["Columns", "Filters", "Pre-Filters", "Actions", "Tiles", "Column Pre-Filters", "General"];

  const allTabs = [
    {
      label: "Columns",
      content: (
        <EditColumns
          afterEffectOfFilter={afterEffectOfFilter}
          tableRef={tableRef}
          setNonSelectedFilter={setNonSelectedFilter}
        />
      )
    },
    {
      label: "Filters",
      content: (
        <EditFilters
          nonSelectedFilter={nonSelectedFilter}
          setNonSelectedFilter={setNonSelectedFilter}
          tableRef={tableRef}
        />
      )
    },
    {
      label: "Pre-Filters",
      content: (
        <PreFilter
          preFilters={recordsviewLayout.pre_filters}
          setPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("pre_filters", data)}
          ownerPreFilters={recordsviewLayout.owner_pre_filters}
          setOwnerPreFilters={(data) => callbackFunctionOfOwnerAnePreFilter("owner_pre_filters", data)}
          table_id={recordsviewLayout.table_id}
          activity_id={recordsviewLayout.activity_id || ""}
          prefiltersJoinedBy={recordsviewLayout.prefilters_joined_by}
          setPrefiltersJoinedBy={(data) => callbackFunctionOfOwnerAnePreFilter("prefilters_joined_by", data)}
          type="recordview"
        />
      )
    },
    {
      label: "Actions",
      content: (
        <EditActions
          actions={recordsviewLayout.multi_select_custom_actions}
          setActions={settingActions}
          device={applicationBlockData.device}
          tableId={applicationBlockData.config.layout.table_id}
          elements={[applicationBlockData]}
        />
      )
    },
    {
      label: "Tiles",
      content: (
        <BlockTiles
          tiles={recordsviewLayout.tiles}
          setTiles={settingTiles}
          table_id={recordsviewLayout.table_id}
          activity_id={recordsviewLayout.activity_id}
          allTableColumns={tableRef.current}
        />
      )
    },
    {
      label: "Column Pre-Filters",
      content: (
        <ColumnPreFilters
          columnList={recordsviewLayout.columns || []}
          tableId={recordsviewLayout.table_id}
          columnPreFilters={recordsviewLayout.column_pre_filters || []}
          setColumnPreFilters={handleChangeColumnPreFilters}
        />
      )
    },
    {
      label: "Location",
      content: (
        <div className="p_3 builder_form">
          <Button variant="secondary" onClick={() => setIsModalOpen("add")} className="ml_auto mt_2 mb_2">
            <MaterialIcon name="add" className="font_size_medium" />
            <p>Add field location</p>
          </Button>
          <div className="field_card">
            <p className="field_custom_label">
              {tableRef.current[recordsviewLayout.location_point]?.prefix}.
              {tableRef.current[recordsviewLayout.location_point]?.display}
            </p>
          </div>
        </div>
      )
    },
    { label: "General", content: <EditGeneralDataOfRV /> }
  ];
  const tabData = allTabs.filter((tab) => tabArray.includes(tab.label));

  return (
    <div>
      <BuilderTabs tabs={tabData} />
      <BuilderModal
        isOpen={isModalOpen || isModalOpen === 0}
        onClose={() => setIsModalOpen(false)}
        modalName={isModalOpen === "add" ? "Add form field" : "Edit form field"}
      >
        <TableTreeModal
          callbackFunction={addFieldLocationCallbackFunction}
          tableId={applicationBlockData.config.layout.table_id}
          folderId={
            applicationBlockData.config.layout?.activity_id
              ? [applicationBlockData.config.layout?.activity_id, "global_fields"]
              : []
          }
          selectedFile={tableRef?.current?.[recordsviewLayout?.location_point]?.id || ""}
        />
      </BuilderModal>
    </div>
  );
};

const EditGeneralDataOfRV = () => {
  const { recordsviewLayout, setRecordsviewLayout, applicationBlockData } = useAppBlocksContext();
  const [allJobs, setAllJobs] = useState([]);
  const [errorLabel, setErrorlabel] = useState("");
  const { blocksExplorerData } = useTreeContext();

  const templateObject = {};
  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=details_view&elements=button`);
      setAllJobs(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleTableTitle = (name, value) => {
    const layoutCopy = { ...recordsviewLayout };
    if (name === "data_limit") {
      value = +value;
    }
    layoutCopy[name] = value;
    setRecordsviewLayout(layoutCopy);
  };

  const handleCheckboxInput = (e) => {
    const { checked, name } = e.target;
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy[name] = checked;
    setRecordsviewLayout(layoutCopy);
  };
  const handleJobTriggerData = (data) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.on_row_action = data;
    setRecordsviewLayout(layoutCopy);
  };

  const getAllDetailsViewList = () => {
    const data = blocksExplorerData
      .find((deviceData) => deviceData.id === applicationBlockData.device)
      .items.find((detailview) => detailview.id.includes("detailsview")).items;
    const statemachineDetsilsview = data.filter(
      (detailview) => detailview.fileInfo?.table_id === applicationBlockData.config.layout.table_id
    );
    return statemachineDetsilsview;
  };

  const handleCatalogInput = (name, value) => {
    setErrorlabel("");
    const newRecordviewLayout = JSON.parse(JSON.stringify(recordsviewLayout));
    const embeddedObj = {
      detailview_id: value
    };
    if (name === "embedded_detailview") {
      newRecordviewLayout.catalog[name] = embeddedObj;
    } else if (name === "catalog_in_row") {
      if (!isNaN(value) && value > 6) {
        setErrorlabel("catalog_in_row");
        return;
      }
      newRecordviewLayout.catalog[name] = value;
    } else {
      newRecordviewLayout.catalog[name] = value;
    }
    setRecordsviewLayout(newRecordviewLayout);
  };
  const handleChangeHiddenColumn = (data) => {
    const layoutCopy = { ...recordsviewLayout };
    layoutCopy.hidden_columns = data;
    setRecordsviewLayout(layoutCopy);
  };
  useEffect(() => {
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const layoutOptions = [
    { id: "table_view", name: "table view only" },
    { id: "catalog_view", name: "catalog view only" },
    { id: "embedded", name: "embedded" },
    { id: "table_and_catalog_view", name: "table and catalog view" },
    { id: "catalog_and_table_view", name: "catalog and table view" }
  ];

  return (
    <div className="recordView_general_tab p_3">
      <div className="builder_form">
        <div className="builder_form">
          <Input
            label="Table title"
            name="title"
            value={recordsviewLayout.title}
            placeholder="Enter table title"
            onChange={(e) => handleTableTitle(e.target.name, e.target.value)}
          />
        </div>
        <div className="builder_form">
          <Input
            label="Enter Data Limit"
            name="data_limit"
            value={recordsviewLayout.data_limit || 50}
            placeholder="Enter data limit"
            onChange={(e) => handleTableTitle(e.target.name, e.target.value)}
          />
        </div>
        <HiddenColumns
          columns={recordsviewLayout.hidden_columns || []}
          handleChange={handleChangeHiddenColumn}
          tableId={recordsviewLayout.table_id}
        />

        <div className="builder_checkbox_outer_wrap">
          <div className="builder_checkbox_outer">
            <Input type="checkbox" name="search" checked={recordsviewLayout.search} onChange={handleCheckboxInput} />
            <label className="checkbox_label">Search Box</label>
          </div>
          <div className="builder_checkbox_outer">
            <Input
              type="checkbox"
              name="allow_download"
              checked={recordsviewLayout.allow_download || false}
              onChange={handleCheckboxInput}
            />
            <label className="checkbox_label">Excel Download</label>
          </div>
          <div className="builder_checkbox_outer">
            <Input
              type="checkbox"
              name="hide_header"
              checked={recordsviewLayout?.hide_header || false}
              onChange={handleCheckboxInput}
            />
            <label className="checkbox_label">Hide Header</label>
          </div>

          <div>
            <SingleSelectBox
              selectedData={recordsviewLayout.layout_type || ""}
              options={layoutOptions}
              onChange={(obj) => handleTableTitle("layout_type", obj.id)}
              placeholder="select"
              label="Select Layout"
            />
            {recordsviewLayout.layout_type === "embedded" && (
              <SingleSelectBox
                selectedData={recordsviewLayout.catalog?.embedded_detailview?.detailview_id}
                options={getAllDetailsViewList()}
                onChange={(obj) => handleCatalogInput("embedded_detailview", obj.id)}
                placeholder="select detailsview"
                label="Select Detailsview"
              />
            )}

            {(recordsviewLayout.layout_type === "catalog_view" ||
              recordsviewLayout.layout_type === "table_and_catalog_view" ||
              recordsviewLayout.layout_type === "catalog_and_table_view") && (
              <>
                <Input
                  label="Cards per row"
                  type="number"
                  value={recordsviewLayout.catalog?.catalog_in_row}
                  name="catalog_in_row"
                  max="6"
                  onChange={(e) => handleCatalogInput(e.target.name, e.target.value)}
                />
                {errorLabel === "catalog_in_row" && (
                  <label className="builder_label label_error">Max 6 cards are allowed</label>
                )}
              </>
            )}
          </div>
          <div className="builder_form">
            <label className="builder_label">On row action</label>
            <SingleJobPopup
              config={recordsviewLayout.on_row_action}
              templateObject={templateObject}
              allJobs={allJobs}
              smId={applicationBlockData.config.layout.table_id}
              device={applicationBlockData.device}
              onChange={handleJobTriggerData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordsViewEditSection;
